import React, { useEffect, useState } from "react";
import Preloader from "../../Components/Preloader";
import Header from "../../Components/Header";
import Footer from "../../Components/Footer";
import { NavLink } from "react-router-dom";
import AOS from "aos";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import About_Seo from "../../SEO/About_Seo";

function AboutUs() {
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 500);
  }, []);
  useEffect(() => {
    AOS.init({
      duration: 650,
      easing: "ease-in-out",
      once: true,
      mirror: false,
    });
  }, []);

  return (
    <>
      {isLoading ? (
        <Preloader />
      ) : (
        <>
          <About_Seo />
          <Header />
          {/* Start Page Banner Area */}
          <div
            className="page-banner-area position-relative overflow-hidden"
            style={{
              backgroundImage: "url(assets/images/hero/hero-image-2.svg)",
            }}
          >
            <div className="container">
              <div className="page-banner-content">
                <h1>About Us</h1>
                <ul>
                  <li>
                    <NavLink to="/">Home</NavLink>
                  </li>
                  <li>About Us</li>
                </ul>
              </div>
            </div>
          </div>
          {/* End Page Banner Area */}

          {/* Start About Area */}
          <div className="why-choose-us-area ptb-100 overflow-hidden">
            <div className="container">
              <div className="row align-items-center">
                <div
                  className="col-lg-6 col-md-12"
                  data-aos="zoom-in-up"
                  data-aos-delay={800}
                >
                  <div className="why-choose-us-content">
                    <div className="section-heading mb-0">
                      <span className="sub-title">About Us</span>
                      <h2>About Ifepay</h2>
                      <p className="mb-2">
                        KP Agency Limited, trading as IFEPAY, is a London-based
                        retail money remittance company established in March
                        2009. We are fully regulated by the Financial Conduct
                        Authority (FCA, FRN: 511981), supervised by HMRC (MLR
                        Registration: XFML00000181717), and registered with
                        Companies House (No. 06833430).
                      </p>
                      <p className="mb-5">
                        As a registered Money Services Business (MSB), we
                        operate under strict UK money laundering regulations,
                        ensuring that every transaction is secure, compliant,
                        and transparent. With over 15 years of combined industry
                        experience, our professional team is dedicated to
                        providing fast, reliable, and customer-focused money
                        transfer services. At IFEPAY, we pride ourselves on
                        delivering excellence, building trust, and maintaining
                        long-term relationships with our clients worldwide.
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  className="col-lg-6 col-md-12"
                  data-aos="zoom-in-up"
                  data-aos-delay={800}
                >
                  <div className="choose-image position-relative">
                    <img
                      className="radius-30"
                      src="assets/images/about/aboutus.jpg"
                      alt="image"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* End About Area */}

          {/* Start App Area */}
          <div className="app-area two pb-100 overflow-hidden">
            <div className="container">
              <div className="download-area bg-color-edf1ee radius-30">
                <div className="row g-4 align-items-center">
                  <div className="col-lg-6 col-md-12" data-aos-delay={200}>
                    <div className="app-image">
                      <img
                        className="radius-30"
                        src="assets/images/app/app-image-5.webp"
                        alt="image"
                      />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-12" data-aos-delay={200}>
                    <div className="section-heading mb-0 ms-auto">
                      <span className="sub-title two bg-color-9edd05 rounded-pill">
                        Download App
                      </span>
                      <h2>Download And Enjoy The Experience</h2>
                      <p className="mb-5">
                        Send money worldwide in seconds with Ifepay app. Enjoy
                        fast transfers, competitive rates, and secure
                        transactions. Track your transfers easily, and all from
                        a user-friendly app.
                      </p>
                      <div className="app-btn">
                        <NavLink
                          to="https://play.google.com/store/apps/details?id=com.remit.IfePay"
                          target="_blank"
                          className="me-3"
                        >
                          <img
                            className="rounded-3"
                            src="assets/images/app/android.png"
                            alt="image"
                          />
                        </NavLink>
                        <NavLink
                          to="https://apps.apple.com/us/app/ifepay/id6744351163"
                          target="_blank"
                        >
                          <img
                            className="rounded-3"
                            src="assets/images/app/apple.png"
                            alt="image"
                          />
                        </NavLink>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* End App Area */}

          {/* Footer Section Here */}
          <Footer />
        </>
      )}
    </>
  );
}

export default AboutUs;
